export const ka = {
  title: 'პირველადი ტყეები',
  subtitle: '30მ, ტროპიკები, UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: 'ფუნქცია',
      value: 'ეს მონაცემთა ნაკრები ასახავს პირველადი ტყეების მასშტაბებს გლობალურ პანტროპიკულ რეგიონებში 2001 წელს.',
    },
    {
      label: 'რეზოლუცია',
      value: '30 × 30 მეტრი',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'პან-ტროპიკული',
    },
    {
      label: 'წყარო',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. მიმდინარე პირველადი ტყის დაკარგვა ბრაზილიაში, კონგოს დემოკრატიულ რესპუბლიკასა და ინდონეზიაში. Environmental Research Letters, 13(7), გვ.074028.',
    },
    {
      label: 'შინაარსის თარიღი',
      value: 2001,
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'პირველადი ტყეები ყველაზე ბიომრავალფეროვნების ტყეებს შორისაა, რომელიც უზრუნველყოფს ეკოსისტემური სერვისების მრავალფეროვნებას, რაც მათ გადამწყვეტს ხდის მიწის გამოყენების ეროვნული დაგეგმვისა და ნახშირბადის აღრიცხვის მონიტორინგისთვის. ეს მონაცემთა ნაკრები განსაზღვრავს პირველადი ტყეებს, როგორც „მომწიფებულ ბუნებრივ ნოტიო ტროპიკულ ტყის საფარს, რომელიც არ ყოფილა ბოლომდე გაწმენდილი და ხელახლა გაშენებული უახლეს ისტორიაში“. მკვლევარებმა Landsat-ის სურათები დაალაგეს ტყის პირველად მონაცემებად, თითოეული რეგიონისთვის ცალკე ალგორითმის გამოყენებით.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. მიმდინარე პირველადი ტყის დაკარგვა ბრაზილიაში, კონგოს დემოკრატიულ რესპუბლიკასა და ინდონეზიაში. Environmental Research Letters, 13(7), გვ.074028. ხელმისაწვდომია Global Forest Watch-ის მეშვეობით 31/01/2025. www.globalforestwatch.org.',
  },
};
